import React, {useEffect} from 'react';
import {quotaIsFull, refetchAdAccountQuota, useAdAccountQuota} from '../../../utils/adAccountQuota';
import {AccountQuotaNotice} from './AccountQuotaNotice';

/**
 * El cupo de cuentas del plan para un formulario de clase, que no puede usar el hook (UD-15): lee el cupo
 * fresco al montarse y le pasa a `children` el aviso del cupo lleno, con sus dos salidas, o `null` si hay
 * lugar o no se sabe (desconocido no es lleno). Un rechazo con números se difunde con
 * `publishAdAccountQuota` y el aviso aparece solo.
 *
 * Quien fue a liberar una cuenta (la salida «Liberar una cuenta» abre otra pestaña) vuelve y encuentra el lugar libre sin
 * cerrar y reabrir: al volver el foco a la ventana se relee el cupo, como en `QuickConnectAccountModal`.
 */
export function AccountQuotaGate({surface, children}) {
    const quota = useAdAccountQuota();

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const onFocus = () => refetchAdAccountQuota();
        window.addEventListener('focus', onFocus);
        return () => window.removeEventListener('focus', onFocus);
    }, []);

    const notice = quotaIsFull(quota) ? <AccountQuotaNotice quota={quota} surface={surface}/> : null;
    return children(notice);
}
